import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\ItemDossier\DeleteItemDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/DeleteItemDossierController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}'
*/
const DeleteItemDossierController = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteItemDossierController.url(args, options),
    method: 'delete',
})

DeleteItemDossierController.definition = {
    methods: ["delete"],
    url: '/api/dossier/{dossier}/item-dossier/{itemDossier}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\DeleteItemDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/DeleteItemDossierController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}'
*/
DeleteItemDossierController.url = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            itemDossier: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        itemDossier: typeof args.itemDossier === 'object'
        ? args.itemDossier.id
        : args.itemDossier,
    }

    return DeleteItemDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{itemDossier}', parsedArgs.itemDossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\ItemDossier\DeleteItemDossierController::__invoke
* @see app/Http/Controllers/Dossier/ItemDossier/DeleteItemDossierController.php
* @route '/api/dossier/{dossier}/item-dossier/{itemDossier}'
*/
DeleteItemDossierController.delete = (args: { dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, itemDossier: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteItemDossierController.url(args, options),
    method: 'delete',
})

export default DeleteItemDossierController